var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6664 46.1668V50.0001C91.6612 58.9852 88.7518 67.7279 83.3719 74.9244C77.992 82.1208 70.43 87.3854 61.8137 89.933C53.1973 92.4806 43.9883 92.1747 35.56 89.0609C27.1317 85.947 19.9357 80.1922 15.0453 72.6545C10.155 65.1169 7.83214 56.2004 8.42333 47.2347C9.01452 38.2691 12.488 29.7348 18.3258 22.9046C24.1636 16.0743 32.0529 11.3142 40.8171 9.33403C49.5813 7.35388 58.7508 8.25982 66.958 11.9168",
    stroke: "#3E55F2",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6667 16.6667L50 58.3751L37.5 45.8751",
    stroke: "#3E55F2",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d00ff624eb5f4fd38fce0959fa15b231.svg";
export { ForwardRef as ReactComponent };